import { render, staticRenderFns } from "./silber.vue?vue&type=template&id=8618d230&scoped=true"
import script from "./silber.vue?vue&type=script&lang=js"
export * from "./silber.vue?vue&type=script&lang=js"
import style0 from "./silber.vue?vue&type=style&index=0&id=8618d230&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8618d230",
  null
  
)

export default component.exports